import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'




import {
    updateInputs,
    showHideModalAddMaestra,
    selectFile,
    AddMaestra
} from '../../actions/maestra'


import { acceptedFiles } from '../../utils/helpers'
const filesTypes = acceptedFiles.map(x => x.type).join()

class ModalAddMaestra extends Component {

    handleCloseModal = () => {
        const modal = document.getElementById('ModalAddMaestra')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#ModalAddMaestra .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalAddMaestra(false), 300)
    }

    handleOnDrop = (files) => {
        if (files.length > 1) {
            toast.warn(`Solo es permitido procesar un archivo a la vez`, { bodyClassName: 'toastify-content toastify-warning' })
            return
        }
        this.props.selectFile(files[0])
    }

    handleOnRejected = (files) => {
        files.forEach(x => {
            toast.warn(`El archivo ${x.name} no es del tipo esperado. ${x.type}`, { bodyClassName: 'toastify-content toastify-warning' })
        })
    }
    

    handleSave = (e) => {
        this.props.AddMaestra()
        this.handleCloseModal(e, "ModalAddMaestra")

    }

    setIcon = (icon) => {
		if (icon) {
			const imageSrc = require('../../img/16px/' + icon)
			return <img src={ imageSrc } />
		}
		return null
	}

    render() {

        const { modalAddMaestra, parametros } = this.props
        if (!modalAddMaestra.get('show')) {
            return null
        }

        return(
            <Modal id="ModalAddMaestra" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ `Agregar nueva maestra` } onClose={ e => this.handleCloseModal(e, "ModalAddMaestra") } />
                <ModalButtonStrip>
                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
                        onClick={ e => this.handleSave(e) }
                        disabled = { (modalAddMaestra.getIn(['data', 'file']) && (modalAddMaestra.getIn(['data', 'file']).size != 0)) ? false : true }
                    />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
						<div className="row">
							<div className="col-md-12">
                                <Dropzone accept={ filesTypes } onDropAccepted={ this.handleOnDrop } onDropRejected={ this.handleOnRejected } className="dropzone1">
                                    <p>Arrastre el archivo</p>
                                </Dropzone>
							</div>
						</div>
						<div className="row" style={{ marginTop: '10px' }}>
							<div className="col-md-12">
                                <div className="form-group">
                                    <div className="div-input-sm">
                                        {
                                            (modalAddMaestra.getIn(['data', 'file']) &&
                                                <div style={{ paddingTop: '1px' }}>
                                                    <span>{this.setIcon(modalAddMaestra.getIn(['data', 'icono']))}</span>
                                                    <span style={{ marginLeft: '4px', verticalAlign: 'bottom' }}>{modalAddMaestra.getIn(['data', 'file']).name}</span>
                                                    <span style={{ marginLeft: '3px', verticalAlign: 'bottom', color: '#ccc' }}>({numeral(modalAddMaestra.getIn(['data', 'file']).size).format('0.0 b')})</span>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="form-group">
									<label className="control-label">Nombre</label>
									<select className="form-control input-sm" value={modalAddMaestra.getIn(['data', 'clasificacion'])} onChange={e => this.props.updateInputs('modalAddMaestra.data.clasificacion', e.target.value)}>
                                        <option value="" disabled={true}>Seleccione el tipo de maestra</option>
                                        {parametros && parametros.map(ele => <option value={ele.get("NOMBRE")}>{ele.get("NOMBRE")}</option>)}
                                    </select>
								</div>
							</div>
						</div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalAddMaestra: state.maestras.get('modalAddMaestra'),
        parametros: state.common.getIn(['parametros', 'MAESTRAS']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalAddMaestra: (show) => dispatch(showHideModalAddMaestra(show)),
        updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        selectFile: (file) => dispatch(selectFile(file)),
        AddMaestra: () => dispatch(AddMaestra()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddMaestra)


// WEBPACK FOOTER //
// ./src/components/Maestra/ModalAddMaestra.jsx